module.exports = __webpack_public_path__ + "static/video_2-eab2fc8244ffb54c0930c94676973107.webm";